import Smooth from "smooth-scrolling";

export default class BaseSmoothWithTouch extends Smooth {
  constructor(opt) {
    super(opt);
    this.scrollAmount = opt.scrollAmount || window.outerWidth / 8;
    this.useDrag = opt.useDrag !== undefined ? opt.useDrag : true; // Explicit check for `useDrag`
    if (opt.direction === "horizontal") {
      this.overrideTouch();
    }
  }

  overrideTouch() {
    let startX = 0;
    let isDragging = false;
    const threshold = 10; // Movement threshold to detect dragging
    const stopMovementThreshold = 10; // Threshold to stop movement when the drag is negligible

    // Touch start event - record initial touch position (X-axis)
    this.dom.section.addEventListener("touchstart", (event) => {
      startX = event.touches[0].clientX;
      isDragging = false; // Reset dragging state
    });

    // Touch move event - handle drag or scroll behavior
    this.dom.section.addEventListener("touchmove", (event) => {
      const currentX = event.touches[0].clientX;
      const deltaX = currentX - startX;

      if (Math.abs(deltaX) > threshold) {
        isDragging = true;
      }

      // Prevent movement if the change is negligible
      if (isDragging) {
        if (Math.abs(deltaX) <= stopMovementThreshold) {
          // Stop further movement if holding with negligible movement
          return;
        }

        if (this.useDrag) {
          this.handleDrag(deltaX);
        } else {
          this.handleScroll(deltaX);
        }
      }
    });

    // Touch end event - reset dragging state
    this.dom.section.addEventListener("touchend", () => {
      if (isDragging) {
        console.log("User finished dragging");
      }
      isDragging = false; // Reset dragging state
    });

    // Touch cancel event - reset dragging state in case of interruption
    this.dom.section.addEventListener("touchcancel", () => {
      console.log("touch cancelled");
      isDragging = false; // Reset dragging state if the touch is interrupted
    });
  }

  // Handle the drag logic based on the direction of the swipe
  handleDrag(deltaX) {
    if (deltaX > 0) {
      console.log("Dragging right");
      this.scrollTo(this.vars.current - this.scrollAmount);
    } else {
      console.log("Dragging left");
      this.scrollTo(this.vars.current + this.scrollAmount);
    }
  }

  // Handle non-drag scroll logic
  handleScroll(deltaX) {
    if (deltaX > 0) {
      this.scrollTo(this.vars.current - this.scrollAmount);
    } else {
      this.scrollTo(this.vars.current + this.scrollAmount);
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/scrollTouch.js